import { jwtDecode } from 'jwt-decode';

export const applicationName = "ukinews";
export const getToken = () => localStorage.getItem(applicationName);

export const decodeToken = () => {
    try {
        const token = getToken();
        
        const payload = jwtDecode(token);
        return payload;
    } catch (ex) {
        return null;
    }
};

export const setToken = (token) =>
    localStorage.setItem(applicationName, token);

export const logoutUser = () => window.localStorage.removeItem(applicationName);

export const removeToken = () => window.localStorage.clear();

export const setToStorage = (key, value) => localStorage.setItem(key, value);

export const getFromStorage = (key) => localStorage.getItem(key);

export const redirect = (redirectUrl) => {
    window.location = redirectUrl;
};

export const redirectInternal = (redirectUrl) => {
    window.location.replace(redirectUrl);
};

export const kFormatter = (num) => {
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
}

export const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        return decoded.exp * 1000 < Date.now();
    } catch (error) {
        return true;
    }
};

export default {
    setToken,
    getToken,
    removeToken,
    applicationName,
    decodeToken,
    setToStorage,
    getFromStorage,
    isTokenExpired,
    logoutUser,
};
